import {message} from "antd";
import {useNavigate} from "react-router-dom";
import {useDeleteSubscriptionApi} from "../../../../react-query-hooks/store/subscriptions/delete-subscription";

export function useDeleteSubscriptionFromEditHook(subscriptionId: number) {
  const deleteMutation = useDeleteSubscriptionApi();
  const navigate = useNavigate();

  function deleteSubscription(): Promise<unknown> {
    return deleteMutation.mutateAsync(subscriptionId).then(() => {
      message.success("Subscription deleted");
      navigate("/products?activeTab=subscriptions");
    });
  }

  return {deleteSubscription};
}
